import { Injector, APP_INITIALIZER } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LOCATION_INITIALIZED } from '@angular/common';

export function appInitializerFactory(
    translate: TranslateService,
    injector: Injector
) {
    return () =>
        new Promise<any>((resolve: any) => {
            const locationInitialized = injector.get(
                LOCATION_INITIALIZED,
                Promise.resolve(null)
            );
            locationInitialized.then(() => {
                let langToSet: string = window.localStorage.getItem('lang');
                if (langToSet !== 'en' && langToSet !== 'ja') {
                    const browserLang = window.navigator.language.split('-')[0];
                    browserLang !== 'en' && browserLang !== 'ja'
                        ? (langToSet = 'en')
                        : (langToSet = browserLang);
                    window.localStorage.setItem('lang', langToSet);
                }
                translate.setDefaultLang('en');
                translate.use(langToSet).subscribe(
                    () => {
                        //console.log(
                        //    `Successfully initialized '${langToSet}' language.'`
                        //);
                    },
                    err => {
                        console.error(
                            `Problem with '${langToSet}' language initialization.'`
                        );
                    },
                    () => {
                        resolve(null);
                    }
                );
            });
        });
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/services/lang-initializer.ts